import React from 'react';
import { services } from '../data/services';
import { PageHero } from '../components/PageHero';
import { ServiceCard } from '../components/ServiceCard';
import { ConsultationCta } from '../components/ConsultationCta';
export function Services() {
  return <main data-id="element-383" data-mp="3ocnu0mtmrfcq">
      <PageHero breadcrumb="Fiduciary Services" eyebrow="FIDUCIARY SERVICES" title="Professional Fiduciary Services" description="Trust administration, estate administration, conservatorship support, personal fiduciary care and care management — handled professionally and discreetly." data-id="element-384" data-mp="3ocdy6ilwmdz4" />

      <section className="bg-white" data-id="element-385" data-mp="b4kpixhqvdw1">
        <div className="mx-auto max-w-shell px-6 py-24" data-id="element-386" data-mp="b3j35wva34z0">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-387" data-mp="64g9f8kr0l6c">
            {services.map(service => <ServiceCard key={service.slug} service={service} data-id="element-388" data-mp="2cumgwv0gszns" />)}
          </div>
        </div>
      </section>

      <section className="bg-mist" data-id="element-389" data-mp="27xvyi116trz7">
        <div className="mx-auto max-w-shell px-6 py-20" data-id="element-390" data-mp="16ot5yprmtowb">
          <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-391" data-mp="16qe0ifdy57u6">
            <div data-id="element-392" data-mp="1bn4cormmrjab">
              <p className="text-[12px] font-medium tracking-[0.22em] text-gold" data-id="element-393" data-mp="1bop7micux48p">
                CHOOSING A SERVICE
              </p>
              <h2 className="mt-5 font-serif text-[34px] leading-[1.15] text-navy-900" data-id="element-394" data-mp="1fno9tv77emwg">
                Not sure which role applies?
              </h2>
            </div>
            <p className="text-[17px] leading-relaxed text-ink/75" data-id="element-395" data-mp="1pesp6w0sk9rt">
              The right service depends on the governing document and on who currently holds
              authority. A trust names a trustee; a court appoints a conservator; a power of
              attorney names an agent. If you are not certain which situation you are in, send us
              the document and we will tell you plainly what the role requires and whether we are
              the right fit for it.
            </p>
          </div>
        </div>
      </section>

      <ConsultationCta data-id="element-396" data-mp="1cbq4twesl864" />
    </main>;
}